import { LOCALE_ID, NgModule, isDevMode } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomepageComponent } from './components/core/home/homepage/homepage.component';
import { LoginComponent } from './components/Authentication/login/login.component';
import { ProfileComponent } from './components/core/profile/profile/profile.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ResigteringComponent } from './components/Authentication/resigtering/resigtering.component';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { HeaderComponent } from './shared/header/header.component';
import { HeaderMobileComponent } from './shared/header.mobile/header.mobile.component';
import { FooterComponent } from './shared/footer/footer.component';
import { VerificationCodeComponent } from './components/Authentication/verification-code/verification-code.component';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { LanguageServiceService } from './services/language-service.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import localeAr from '@angular/common/locales/ar-AE';
import { LoadingComponent } from './shared/loading/loading.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { InvoiceComponent } from './components/core/orders/invoice/invoice.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { NodataComponent } from './shared/nodata/nodata.component';
import { ForgetPasswordComponent } from './components/Authentication/forget-password/forget-password.component';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// or
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { ChangePasswordComponent } from './components/core/profile/change-password/change-password.component';
import { MatTableModule } from '@angular/material/table';
import { WelcomeComponent } from './components/core/static pages/welcome/welcome.component';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { ServiceWorkerModule } from '@angular/service-worker';
import { ContactUsComponent } from './components/core/static pages/contact-us/contact-us.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { AddorderclientComponent } from './components/core/orders/addorderclient/addorderclient.component';
import { OrdercompletedComponent } from './components/core/orders/ordercompleted/ordercompleted.component';
import { ProductsbypetComponent } from './components/core/home/productsbypet/productsbypet.component';
import { ProductsbycatagoryComponent } from './components/core/home/productsbycatagory/productsbycatagory.component';
import { ProductsbybrandComponent } from './components/core/home/productsbybrand/productsbybrand.component';
import { ProductdetailsComponent } from './components/core/home/productdetails/productdetails.component';
import { AllpetsComponent } from './components/core/home/allpets/allpets.component';
import { AllcategoriesComponent } from './components/core/home/allcategories/allcategories.component';
import { ProductmostsalesComponent } from './components/core/home/productmostsales/productmostsales.component';
import { AllbrandsComponent } from './components/core/home/allbrands/allbrands.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { CartComponent } from './components/core/cart/cart/cart.component';
import { EmptycartComponent } from './components/core/cart/emptycart/emptycart.component';
import { ProducthotdealsComponent } from './components/core/home/producthotdeals/producthotdeals.component';
import { EmptyordersComponent } from './components/core/orders/emptyorders/emptyorders.component';
import { OrdersComponent } from './components/core/orders/orders/orders.component';
import { UseraddressesComponent } from './components/core/profile/addresses/useraddresses/useraddresses.component';
import { UserwalletComponent } from './components/core/profile/wallet/userwallet/userwallet.component';
import { UsernotificationsComponent } from './components/core/profile/notifications/usernotifications/usernotifications.component';
import { AddaddressComponent } from './components/core/profile/addresses/addaddress/addaddress.component';
import { EmptyaddressesComponent } from './components/core/profile/addresses/emptyaddresses/emptyaddresses.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { MapsComponent } from './components/core/profile/addresses/maps/maps.component';
import { ProductComponent } from './components/core/home/product/product.component';

import { OrderdetailsComponent } from './components/core/orders/orderdetails/orderdetails.component';
import { NointernetComponent } from './components/core/static pages/nointernet/nointernet.component';
import { SearchpageComponent } from './components/core/search/searchpage/searchpage.component';
import { NoresultComponent } from './components/core/search/noresult/noresult.component';
import { ResultComponent } from './components/core/search/result/result.component';
import { RefundpolicyComponent } from './components/core/profile/refundpolicy/refundpolicy.component';
import { AboutUsComponent } from './components/core/profile/about-us/about-us.component';
import { OffersComponent } from './components/core/home/offers/offers.component';
import { ProductrecommendationComponent } from './components/core/home/productrecommendations/productrecommendation.component';
import { OnlinePaymentComponent } from './components/core/orders/onlinepayment/onlinepayment.component';
import { SafeUrlPipe } from './safe-url.pipe';
// import { registerLocaleData } from '@angular/common';
import { provideTransloco, TRANSLOCO_CONFIG, TRANSLOCO_LOADER, translocoConfig, TranslocoModule } from '@ngneat/transloco';
import { TranslocoHttpLoader } from './services/translocohttploader';
import { DealsComponent } from './components/core/home/deals/deals.component';
import { BundleComponent } from './components/core/home/bundle/bundle.component';
import { BundledetailsComponent } from './components/core/home/bundledetails/bundledetails.component';
import { DailyoffersComponent } from './components/core/home/dailyoffers/dailyoffers.component';
import { MostratedComponent } from './components/core/home/mostrated/mostrated.component';
import { LuckywheelComponent } from './components/core/home/luckywheel/luckywheel.component';
import { ShopingComponent } from './components/core/home/shoping/shoping.component';
import { DailyproductsComponent } from './components/core/home/dailyproducts/dailyproducts.component';
import { ClinicserviceComponent } from './components/core/clinic/clinicservice/clinicservice.component';
import { BookclinicserviceComponent } from './components/core/clinic/bookclinicservice/bookclinicservice.component';
import { ClinicservicesComponent } from './components/core/clinic/clinicservices/clinicservices.component';
import { MyclinicservicesComponent } from './components/core/clinic/myclinicservices/myclinicservices.component';
import { EmptyservicesComponent } from './components/core/clinic/emptyservices/emptyservices.component';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// registerLocaleData(localeAr);
@NgModule({
  declarations: [
    AppComponent,
    HomepageComponent,
    LoginComponent,
    ProfileComponent,
    ResigteringComponent,
    HeaderComponent,
    FooterComponent,
    HeaderMobileComponent,
    VerificationCodeComponent,
    LoadingComponent,
    WelcomeComponent,
    InvoiceComponent,
    NodataComponent,
    ForgetPasswordComponent,
    OrdercompletedComponent,
    ChangePasswordComponent,
    AddorderclientComponent,
    AllbrandsComponent,
    ContactUsComponent,
    ProductsbypetComponent,
    ProductsbycatagoryComponent,
    ProductsbybrandComponent,
    ProductdetailsComponent,
    AllpetsComponent,
    AllcategoriesComponent,
    ProductmostsalesComponent,
    CartComponent,
    EmptycartComponent,
    ProducthotdealsComponent,
    ProductrecommendationComponent,
    EmptyordersComponent,
    OrdersComponent,
    UseraddressesComponent,
    UserwalletComponent,
    UsernotificationsComponent,
    AddaddressComponent,
    EmptyaddressesComponent,
    MapsComponent,
    ProductComponent,
    OrderdetailsComponent,
    NointernetComponent,
    SearchpageComponent,
    NoresultComponent,
    ResultComponent,
    RefundpolicyComponent,
    AboutUsComponent,
    OffersComponent,
    OnlinePaymentComponent,
    SafeUrlPipe,
    DealsComponent,
    BundleComponent,
    BundledetailsComponent,
    DailyoffersComponent,
    MostratedComponent,
    LuckywheelComponent,
    ShopingComponent,
    DailyproductsComponent,
        ClinicserviceComponent,
    BookclinicserviceComponent,
    ClinicservicesComponent,
    MyclinicservicesComponent,
    EmptyservicesComponent

  ],
  imports: [
    BrowserModule,
    MatPaginatorModule,
    LazyLoadImageModule,
    AppRoutingModule,
    FormsModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatSelectModule,
    MatInputModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatTableModule,
    ZXingScannerModule,
    GoogleMapsModule,
    TranslocoModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: 'en-US',
    },
    // { provide: LocationStrategy, useClass: HashLocationStrategy },
    provideTransloco({
      config: {
        availableLangs: ['en', 'ar'],
        defaultLang: 'en',
        fallbackLang: 'en',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    provideClientHydration(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
